/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useState, useEffect } from 'react';
import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

interface Props extends Omit<TooltipProps, 'title'> {
  isDisabled?: boolean;
  overflow?: boolean;
  title?: Element | string;
  forceHoverListener?: boolean;
}

const overflowStyle = {
  whiteSpace: 'nowrap' as 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
};

const Tooltip = ({
  isDisabled,
  overflow = true,
  forceHoverListener = false,
  ...props
}: Props) => {
  const [isOverflow, setIsOverflow] = useState(false);
  const textElementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textElementRef.current) {
      setIsOverflow(
        textElementRef.current.scrollWidth > textElementRef.current.clientWidth,
      );
    }
  }, []);

  return (
    <MuiTooltip
      {...props}
      placement={props.placement || 'top'}
      enterNextDelay={1000}
      title={(
        <Box overflow="auto" maxHeight={200}>
          {props.title || props.children}
        </Box>
      )}
      disableHoverListener={forceHoverListener ? false : (isDisabled ? true : (overflow && !isOverflow))}
    >
      <Box
        ref={textElementRef}
        {...(overflow && {
          style: overflowStyle,
        })}
      >
        {props.children}
      </Box>
    </MuiTooltip>
  );
};

export default Tooltip;
